<!--采购配件统计-崇峰定制-->
<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">汽配编码</div>
                    <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="汽配编码/互换码"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                    <div class="search-name">适用车型</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="适用车型"></el-input>
                    <div class="search-name">品牌</div>
                    <div class="search-item goods-categories">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">汽配分类</div>
                    <div class="search-item goods-categories">
                        <el-select
                            style="width: 100%"
                            v-model="searchData.APCate"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            multiple
                            collapse-tags
                            size="small"
                            :remote-method="searchCate"
                            v-select-scroll-more="searchCateLoad"
                            @visible-change="cateVisibleChange($event)"
                            placeholder="请输入汽配分类"
                        >
                            <el-option v-for="optionItem in apCategoryList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="search-name">客户名称</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.CustName"
                        remote
                        filterable
                        clearable
                        placeholder="请输入客户名称"
                        :remote-method="searchCustomer"
                        v-select-scroll-more="searchCustomerLoad"
                        @visible-change="customerVisibleChange($event)"
                        popper-class="my-select"
                    >
                        <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                            <div class="name">
                                {{ item.EntpCusName }}
                                <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                            </div>
                        </el-option>
                    </el-select>
                    <div class="search-name">支付方式</div>
                    <el-select class="search-item" size="small" v-model="searchData.PayType" clearable @visible-change="payTypeVisibleChange($event)">
                        <el-option label="全部" value></el-option>
                        <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">单号</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.OrderNo" placeholder="请输入单号"></el-input>
                    <div class="search-name">单据类型</div>
                    <el-select v-model="searchData.OrderType" size="small" class="search-item" filterable placeholder="请选择" clearable>
                        <el-option label="采购单" value="0"></el-option>
                        <el-option label="退货单" value="1"></el-option>
                    </el-select>
                    <div class="search-name">操作人</div>
                    <el-select
                        v-model="searchData.Operator"
                        size="small"
                        class="search-item"
                        filterable
                        placeholder="请选择"
                        clearable
                        @visible-change="cusSiVisibleChange($event)"
                    >
                        <el-option v-for="(item, index) in sIdList" :key="index" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">时间区间</div>
                    <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button size="small" icon="el-icon-download" class="search-btn btn-primary" @click="exportData" :readonly="saveLoading"
                        >导出<span v-if="tableDataLength">（{{ tableDataLength }}）</span>
                    </el-button>
                    <el-button
                        size="small"
                        icon="el-icon-setting"
                        type="primary"
                        class="search-btn"
                        @click="
                            () => {
                                tableSetsVisible = true;
                            }
                        "
                        >表格设置</el-button
                    >
                </div>
            </div>

            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%" @sort-change="sortChange" :tableCode="tableCode">
                    <!-- <el-table-column
          type="selection"
          width="55"
          reserve-selection
          fixed="left"
        ></el-table-column>             -->
                    <el-table-column
                        v-if="columnShowSets.APCode.IsShow"
                        :min-width="columnShowSets.APCode.Width > 0 ? columnShowSets.APCode.Width + 'px' : '180px'"
                        :label="columnShowSets.APCode.ColumnName"
                        prop="APCode"
                        fixed="left"
                        sortable="custom"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.GoodCode.IsShow"
                        :min-width="columnShowSets.GoodCode.Width > 0 ? columnShowSets.GoodCode.Width + 'px' : '200px'"
                        :label="columnShowSets.GoodCode.ColumnName"
                        prop="GoodCode"
                        sortable="custom"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.GoodName.IsShow"
                        :min-width="columnShowSets.GoodName.Width > 0 ? columnShowSets.GoodName.Width + 'px' : '150px'"
                        :label="columnShowSets.GoodName.ColumnName"
                        prop="GoodName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.AutoSerise.IsShow"
                        :min-width="columnShowSets.AutoSerise.Width > 0 ? columnShowSets.AutoSerise.Width + 'px' : '250px'"
                        :label="columnShowSets.AutoSerise.ColumnName"
                        prop="AutoSerise"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.APCate.IsShow"
                        :min-width="columnShowSets.APCate.Width > 0 ? columnShowSets.APCate.Width + 'px' : '100px'"
                        :label="columnShowSets.APCate.ColumnName"
                        prop="APCate"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.Brand.IsShow"
                        :min-width="columnShowSets.Brand.Width > 0 ? columnShowSets.Brand.Width + 'px' : '90px'"
                        :label="columnShowSets.Brand.ColumnName"
                        prop="Brand"
                        show-overflow-tooltip
                    ></el-table-column>

                    <el-table-column
                        v-if="columnShowSets.SalesPrice.IsShow"
                        :min-width="columnShowSets.SalesPrice.Width > 0 ? columnShowSets.SalesPrice.Width + 'px' : '90px'"
                        :label="columnShowSets.SalesPrice.ColumnName"
                        prop="SalesPrice"
                        sortable="custom"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.OrderType == '0' ? scope.row.SalesPrice : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.SalesCount.IsShow"
                        :min-width="columnShowSets.SalesCount.Width > 0 ? columnShowSets.SalesCount.Width + 'px' : '90px'"
                        :label="columnShowSets.SalesCount.ColumnName"
                        prop="SalesCount"
                        sortable="custom"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.OrderType == '0' ? scope.row.SalesCount : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.SalesTotalPrice.IsShow"
                        :min-width="columnShowSets.SalesTotalPrice.Width > 0 ? columnShowSets.SalesTotalPrice.Width + 'px' : '110px'"
                        :label="columnShowSets.SalesTotalPrice.ColumnName"
                        prop="SalesTotalPrice"
                        sortable="custom"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.OrderType == '0' ? scope.row.SalesTotalPrice : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.SalesNo.IsShow"
                        :width="columnShowSets.SalesNo.Width > 0 ? columnShowSets.SalesNo.Width + 'px' : '140px'"
                        :label="columnShowSets.SalesNo.ColumnName"
                        prop="SalesNo"
                        sortable="custom"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.WarehouseInTime.IsShow"
                        :width="columnShowSets.WarehouseInTime.Width > 0 ? columnShowSets.WarehouseInTime.Width + 'px' : '110px'"
                        :label="columnShowSets.WarehouseInTime.ColumnName"
                        prop="WarehouseInTime"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.PayType.IsShow"
                        :width="columnShowSets.PayType.Width > 0 ? columnShowSets.PayType.Width + 'px' : '90px'"
                        :label="columnShowSets.PayType.ColumnName"
                        prop="PayType"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.CustName.IsShow"
                        :min-width="columnShowSets.CustName.Width > 0 ? columnShowSets.CustName.Width + 'px' : '100px'"
                        :label="columnShowSets.CustName.ColumnName"
                        prop="CustName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.ReturnCount.IsShow"
                        :width="columnShowSets.ReturnCount.Width > 0 ? columnShowSets.ReturnCount.Width + 'px' : '90px'"
                        :label="columnShowSets.ReturnCount.ColumnName"
                        prop="ReturnCount"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.OrderType == '1' ? scope.row.ReturnCount : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.ReturnPrice.IsShow"
                        :min-width="columnShowSets.ReturnPrice.Width > 0 ? columnShowSets.ReturnPrice.Width + 'px' : '90px'"
                        :label="columnShowSets.ReturnPrice.ColumnName"
                        prop="ReturnPrice"
                        sortable="custom"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.OrderType == '1' ? scope.row.ReturnPrice : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.ReturnTotalPrice.IsShow"
                        :width="columnShowSets.ReturnTotalPrice.Width > 0 ? columnShowSets.ReturnTotalPrice.Width + 'px' : '110px'"
                        :label="columnShowSets.ReturnTotalPrice.ColumnName"
                        prop="ReturnTotalPrice"
                        sortable="custom"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.OrderType == '1' ? scope.row.ReturnTotalPrice : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.ReturnNo.IsShow"
                        :min-width="columnShowSets.ReturnNo.Width > 0 ? columnShowSets.ReturnNo.Width + 'px' : '140px'"
                        :label="columnShowSets.ReturnNo.ColumnName"
                        prop="ReturnNo"
                        sortable="custom"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.WarehouseOutTime.IsShow"
                        :min-width="columnShowSets.WarehouseOutTime.Width > 0 ? columnShowSets.WarehouseOutTime.Width + 'px' : '110px'"
                        :label="columnShowSets.WarehouseOutTime.ColumnName"
                        prop="WarehouseOutTime"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.Operator.IsShow"
                        :width="columnShowSets.Operator.Width > 0 ? columnShowSets.Operator.Width + 'px' : '100px'"
                        :label="columnShowSets.Operator.ColumnName"
                        prop="Operator"
                        show-overflow-tooltip
                    ></el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
                <div class="dialog-content" v-if="timeVisible">
                    <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closeDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
                <div class="dialog-content" v-if="tableSetsVisible">
                    <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
                </div>
            </el-dialog>
            <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
// import elTableColumn from "@/components/common/chjtablecolumn";
import timePicker from '@/components/common/timePicker';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import tableSets from '@/components/common/tableSets.vue';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        breadcrumb,
        timePicker,
        // elTableColumn,
        tableSets
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            tableSetsVisible: false,
            tableCode: 'PurAutoPartStatTable',
            timeVisible: false,
            brand: [],
            apCategoryList: [],
            payWayList: [],
            sIdList: [],
            searchData: {
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                CustName: '',
                PayType: '',
                OrderNo: '',
                OrderType: '',
                Operator: '',
                UId: userMsg.EmployeeId,
                StatType: '1',
                page: 1,
                limit: 15
            },
            dialogVisible: false,
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            columnShowSets: {
                APCode: { ColumnName: '', IsShow: false, Width: 0 },
                GoodCode: { ColumnName: '', IsShow: false, Width: 0 },
                GoodName: { ColumnName: '', IsShow: false, Width: 0 },
                AutoSerise: { ColumnName: '', IsShow: false, Width: 0 },
                APCate: { ColumnName: '', IsShow: false, Width: 0 },
                Brand: { ColumnName: '', IsShow: false, Width: 0 },
                SalesTotalPrice: { ColumnName: '', IsShow: false, Width: 0 },
                SalesPrice: { ColumnName: '', IsShow: false, Width: 0 },
                SalesCount: { ColumnName: '', IsShow: false, Width: 0 },
                SalesNo: { ColumnName: '', IsShow: false, Width: 0 },
                WarehouseOutTime: { ColumnName: '', IsShow: false, Width: 0 },
                PayType: { ColumnName: '', IsShow: false, Width: 0 },
                CustName: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnCount: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnPrice: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnTotalPrice: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnNo: { ColumnName: '', IsShow: false, Width: 0 },
                WarehouseInTime: { ColumnName: '', IsShow: false, Width: 0 },
                Operator: { ColumnName: '', IsShow: false, Width: 0 }
            },
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            cateForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            saveLoading: false,
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0 //已保存数
        };
    },
    created() {
        if (this.tableCode) {
            this.getSetsData().then(() => {
                this.getTableData();
            });
        }
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
    },
    methods: {
        // getRowKey(row){
        //      return row.GoodsId;
        // },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.searchData.page = 1;
            this.handleSearch();
        },
        searchGoodsBrand() {
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 客户名称列表，搜索
        async searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomerLoad() {
            if (this.cusOptions && this.cusOptions.length > 0) {
                this.cusForm.Page += 1;
            } else {
                this.cusForm.Page = 1;
            }
            this.searchCustomer();
        },
        // 搜索汽配分类
        searchCate(key) {
            if (![undefined].includes(key)) {
                this.cateForm.Page = 1;
                this.cateForm.stopLoad = false;
                this.cateForm.key = key;
                this.apCategoryList = [];
            }
            if (this.cateForm.stopLoad) return;
            this.loading = true;
            this.$util
                .getEntpApCategoryList(this.cateForm.key, this.cateForm.Page, this.cateForm.Limit)
                .then(data => {
                    if (!data) return;
                    this.cateForm.stopLoad = data.length < this.cateForm.Limit;
                    this.apCategoryList = [...this.apCategoryList, ...data];
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        searchCateLoad() {
            this.cateForm.Page += 1;
            this.searchCate();
        },
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        getCusSIdList() {
            this.$util.getSalemanList().then(data => {
                this.sIdList = data;
            });
        },

        // 重置表单
        resetSearch() {
            this.searchData = {
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                CustName: '',
                PayType: '',
                OrderNo: '',
                OrderType: '',
                Operator: '',
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                StatType: '1',
                page: 1,
                limit: this.commonPageSize
            };
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/PurAPStatistics',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        this.tableData = [];
                        this.tableDataLength = 0;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.apCategoryList.length == 0) that.searchCate('');
            }
        },
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.cusOptions.length == 0) that.searchCustomer('');
            }
        },
        payTypeVisibleChange() {
            let that = this;
            if (event) {
                if (that.payWayList.length == 0) that.getPay();
            }
        },
        cusSiVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.sIdList.length == 0) that.getCusSIdList();
            }
        },
        sortChange(event) {
            if (event.prop) {
                this.searchData.SortProp = event.prop;
                this.searchData.SortType = event.order;
            } else {
                this.searchData.SortProp = '';
                this.searchData.SortType = '';
            }

            this.searchData.page = 1;
            this.getTableData();
        },

        closeDialog(isEdit) {
            this.tableSetsVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        },
        getSetsData() {
            return this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'APCode':
                            this.columnShowSets.APCode.IsShow = item.IsShow;
                            this.columnShowSets.APCode.Width = item.Width;
                            this.columnShowSets.APCode.ColumnName = item.ColumnName;
                            break;
                        case 'GoodCode':
                            this.columnShowSets.GoodCode.IsShow = item.IsShow;
                            this.columnShowSets.GoodCode.Width = item.Width;
                            this.columnShowSets.GoodCode.ColumnName = item.ColumnName;
                            break;
                        case 'GoodName':
                            this.columnShowSets.GoodName.IsShow = item.IsShow;
                            this.columnShowSets.GoodName.Width = item.Width;
                            this.columnShowSets.GoodName.ColumnName = item.ColumnName;
                            break;
                        case 'AutoSerise':
                            this.columnShowSets.AutoSerise.IsShow = item.IsShow;
                            this.columnShowSets.AutoSerise.Width = item.Width;
                            this.columnShowSets.AutoSerise.ColumnName = item.ColumnName;
                            break;
                        case 'APCate':
                            this.columnShowSets.APCate.IsShow = item.IsShow;
                            this.columnShowSets.APCate.Width = item.Width;
                            this.columnShowSets.APCate.ColumnName = item.ColumnName;
                            break;
                        case 'Brand':
                            this.columnShowSets.Brand.IsShow = item.IsShow;
                            this.columnShowSets.Brand.Width = item.Width;
                            this.columnShowSets.Brand.ColumnName = item.ColumnName;
                            break;
                        case 'SalesTotalPrice':
                            this.columnShowSets.SalesTotalPrice.IsShow = item.IsShow;
                            this.columnShowSets.SalesTotalPrice.Width = item.Width;
                            this.columnShowSets.SalesTotalPrice.ColumnName = item.ColumnName;
                            break;
                        case 'SalesPrice':
                            this.columnShowSets.SalesPrice.IsShow = item.IsShow;
                            this.columnShowSets.SalesPrice.Width = item.Width;
                            this.columnShowSets.SalesPrice.ColumnName = item.ColumnName;
                            break;
                        case 'SalesCount':
                            this.columnShowSets.SalesCount.IsShow = item.IsShow;
                            this.columnShowSets.SalesCount.Width = item.Width;
                            this.columnShowSets.SalesCount.ColumnName = item.ColumnName;
                            break;
                        case 'SalesNo':
                            this.columnShowSets.SalesNo.IsShow = item.IsShow;
                            this.columnShowSets.SalesNo.Width = item.Width;
                            this.columnShowSets.SalesNo.ColumnName = item.ColumnName;
                            break;
                        case 'WarehouseOutTime':
                            this.columnShowSets.WarehouseOutTime.IsShow = item.IsShow;
                            this.columnShowSets.WarehouseOutTime.Width = item.Width;
                            this.columnShowSets.WarehouseOutTime.ColumnName = item.ColumnName;
                            break;
                        case 'PayType':
                            this.columnShowSets.PayType.IsShow = item.IsShow;
                            this.columnShowSets.PayType.Width = item.Width;
                            this.columnShowSets.PayType.ColumnName = item.ColumnName;
                            break;
                        case 'CustName':
                            this.columnShowSets.CustName.IsShow = item.IsShow;
                            this.columnShowSets.CustName.Width = item.Width;
                            this.columnShowSets.CustName.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnCount':
                            this.columnShowSets.ReturnCount.IsShow = item.IsShow;
                            this.columnShowSets.ReturnCount.Width = item.Width;
                            this.columnShowSets.ReturnCount.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnPrice':
                            this.columnShowSets.ReturnPrice.IsShow = item.IsShow;
                            this.columnShowSets.ReturnPrice.Width = item.Width;
                            this.columnShowSets.ReturnPrice.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnTotalPrice':
                            this.columnShowSets.ReturnTotalPrice.IsShow = item.IsShow;
                            this.columnShowSets.ReturnTotalPrice.Width = item.Width;
                            this.columnShowSets.ReturnTotalPrice.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnNo':
                            this.columnShowSets.ReturnNo.IsShow = item.IsShow;
                            this.columnShowSets.ReturnNo.Width = item.Width;
                            this.columnShowSets.ReturnNo.ColumnName = item.ColumnName;
                            break;
                        case 'WarehouseInTime':
                            this.columnShowSets.WarehouseInTime.IsShow = item.IsShow;
                            this.columnShowSets.WarehouseInTime.Width = item.Width;
                            this.columnShowSets.WarehouseInTime.ColumnName = item.ColumnName;
                            break;
                        case 'Operator':
                            this.columnShowSets.Operator.IsShow = item.IsShow;
                            this.columnShowSets.Operator.Width = item.Width;
                            this.columnShowSets.Operator.ColumnName = item.ColumnName;
                            break;
                    }
                });
            });
        },
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选商品');
                return;
            }
            that.saveLoading = true;

            // //每次取100条数据
            let saveLimit = 50;
            //   if(that.tableDataLength>20000)
            //     saveLimit=20000;
            //   else
            //     saveLimit=that.tableDataLength;

            let params = { ...that.searchData };
            params.page = that.currtPage;
            params.limit = saveLimit;
            that.$util
                .axiosPost({
                    url: '/api/DataStatistics/ExportStatGoods',
                    data: params,
                    hideLoading: true
                })
                .then(resp => {
                    that.saveCount += saveLimit;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.tableDataLength);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;

                    if (that.tableDataLength <= that.saveCount) {
                        setTimeout(function () {
                            that.$util.successMsg('导出成功');
                            that.saveLoading = false;

                            that.percentage = 0;
                            that.saveCount = 0;
                            that.currtPage = 1;
                            that.$util.exportFile({
                                url: '/api/DataStatistics/ExportStatGoods',
                                data: {
                                    uid: that.userMsg.EmployeeId,
                                    oType: '1'
                                }
                            });
                        }, 1000);
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.saveLoading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 16.6%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .image-sup {
        width: 25px;
        height: 25px;
        margin-right: 4px;
    }
    .image-cus {
        width: 25px;
        height: 25px;
    }
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 99999;
}
</style>
